import { Brand, createBranded } from '@deltasierra/type-utilities';

export type PublishedArtifactGroupId = Brand<number, 'PublishedArtifactGroupId'>;
export const PublishedArtifactGroupId = createBranded<PublishedArtifactGroupId>();
